define('collections/questionnaire/questionnaires',[
    'underscore',
    'backbone',
    'utils',
    // services
    'services/api',
    // parent
    'src/plugins/infinite-collection',
    // models
    'models/questionnaire/questionnaire'
], function(
    _, Backbone, U,
    // services
    API,
    // parent
    InfiniteCollection,
    // models
    MQuestionnaire
) {

    var CQuestionnaires = InfiniteCollection.extend({
        model: MQuestionnaire,
        url: API.url('questionnaires/q/'),


    });

    return CQuestionnaires;

});

